"use strict";exports.secondsToMs=function(s){return 1e3*s};
//# sourceMappingURL=secondsToMs.cjs.map
